export const GET_ALL_FACTORY_OWNER = "GET_ALL_FACTORY_OWNER";
export const GET_ALL_FACTORY_OWNER_SUCCESS = "GET_ALL_FACTORY_OWNER_SUCCESS";
export const GET_ALL_FACTORY_OWNER_FAIL = "GET_ALL_FACTORY_OWNER_FAIL";

export const GET_ALL_FACTORY_LIST = "GET_ALL_FACTORY_LIST";
export const GET_ALL_FACTORY_LIST_SUCCESS = "GET_ALL_FACTORY_LIST_SUCCESS";
export const GET_ALL_FACTORY_LIST_FAIL = "GET_ALL_FACTORY_LIST_FAIL";

export const GET_ALL_SPTF_CREATE = "GET_ALL_SPTF_CREATE";
export const GET_ALL_SPTF_CREATE_SUCCESS = "GET_ALL_SPTF_CREATE_SUCCESS";
export const GET_ALL_SPTF_CREATE_FAIL = "GET_ALL_SPTF_CREATE_FAIL";

export const CREATE_EDIT_API_SPTF = "CREATE_EDIT_API_SPTF";
export const CREATE_SPTF_DISABLE = "CREATE_SPTF_DISABLE";

export const SEARCH_REQUEST = 'SEARCH_REQUEST';
export const SEARCH_SUCCESS = 'SEARCH_SUCCESS';
export const SEARCH_FAILURE = 'SEARCH_FAILURE';

export const GET_SPTF_RECOVERY_REQUEST = 'GET_SPTF_RECOVERY_REQUEST';
export const GET_SPTF_RECOVERY_SUCCESS = 'GET_SPTF_RECOVERY_SUCCESS';
export const GET_SPTF_RECOVERY_FAILURE = 'GET_SPTF_RECOVERY_FAILURE';

export const UPDATE_SPTF_RECOVERY_REQUEST = 'UPDATE_SPTF_RECOVERY_REQUEST';
export const UPDATE_SPTF_RECOVERY_SUCCESS = 'UPDATE_SPTF_RECOVERY_SUCCESS';
export const UPDATE_SPTF_RECOVERY_FAILURE = 'UPDATE_SPTF_RECOVERY_FAILURE';

export const DELETE_SPTF_RECOVERY_REQUEST = 'DELETE_SPTF_RECOVERY_REQUEST';
export const DELETE_SPTF_RECOVERY_SUCCESS = 'DELETE_SPTF_RECOVERY_SUCCESS';
export const DELETE_SPTF_RECOVERY_FAILURE = 'DELETE_SPTF_RECOVERY_FAILURE';